<div>
  <div class="wm-errornotification-header">ERROR</div>
  <div class="wm-errornotification-header-msg">
    A critical error has occurred@if (errorId) {
    <span> ({{errorId}})</span>
    }:
  </div>
  @if (errors && errors !== []) {
    @for (error of errors; track error) {
      <div class="wm-errornotification-msg">{{error}}</div>
    }
  }
  <div class="wm-errornotification-btn">
    <button pButton class="p-button-outlined" (click)="reloadWindow()">Reload webmate</button>
  </div>
  <div class="wm-errornotification-admin-msg">If the problem still occurs, please contact your administrator.</div>
</div>
